import { Colors } from 'basic-ui-lib/constants';
import { ConfigProvider, Input as InputAnt } from 'antd';
import { PasswordProps } from 'antd/es/input';
import styled from 'styled-components';

const InputPassword = (props: PasswordProps) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          controlHeight: 48,
          borderRadius: 5,
        },
        components: {
          Input: {
            colorBorder: Colors.neutral.border[3],
            activeBorderColor: Colors.primary[6],
            hoverBorderColor: Colors.primary[6],
            fontSize: 14,
            fontFamily: 'Poppins',
            colorText: Colors.neutral.text[5],
            fontWeightStrong: 500,
            colorTextPlaceholder: Colors.neutral.text[4],
          },
        },
      }}
    >
      <StyledInputPassword {...props} />
    </ConfigProvider>
  );
};

export default InputPassword;

const StyledInputPassword = styled(InputAnt.Password)`
  width: 100%;
  font-weight: 500;

  .ant-input-prefix {
    margin-right: 10px;
  }

  .ant-input {
    font-weight: 500;
  }

  .ant-input-suffix {
    .ant-input-password-icon {
      color: ${Colors.neutral.icon[2]};
      font-size: 16px;
      
      &:hover {
        color: ${Colors.neutral.icon[3]};
      }
    }
  }
`;
